/**

 * Controller / brand constants for legal pages.

 * Empty `pec` is omitted in UI. Company P.IVA not set yet (persona fisica — CF only).

 */



export const LEGAL = {

  siteName: "Nestly",

  siteUrl: "https://nestly.studio",

  lastUpdated: "2026-08-08",

  controller: {

    legalName: "Damian Perez Mendoza",

    address: "Via San Simone 2P",

    vatOrTaxId: "PRZDNL99A20Z504C",

    email: "nestly.studio.dlpm@gmail.com",

    pec: "",

  },

  contactEmail: "nestly.studio.dlpm@gmail.com",

  analyticsEnabledByEnv: process.env.REACT_APP_ENABLE_ANALYTICS === "true",

};



/** True when any controller field still carries an operator placeholder. */

export function hasControllerPlaceholders() {

  const { legalName, address, vatOrTaxId, pec } = LEGAL.controller;

  return [legalName, address, vatOrTaxId, pec].some((value) =>

    String(value).includes("[DA COMPILARE"),

  );

}


